import './lazy_load';
import './language_dropdown';
import './tooltip';
import '@wework/ray-core';
import instantiateWWWFormUtils from '@wework/www-form-utils';

import { sendTimingEvents } from './timing';
import { onContentLoaded } from './on_content_loaded';
import { fetchGeoData } from './geo';
import { onPolyfillsLoaded, closestElementPolyfill } from './util/polyfills';
import { isIE, isOpera } from './util/user_agent';
import hookUpContactUs from './contact_us';
import { initNavTrackingListeners } from './nav';
import {
  setupPhoneNumbersOnPage,
  setUpMobileMenuButtons,
  setUpGeoDataStuffAndListenForFooterInteractionsAndInitLocationSearch,
  waitForGTMheapIdToBeSet
} from './on_load_functions_for_main';
import { removeNoJsClass } from './seo';

// This file is a giant cluster.

export async function doRandomStuffAtFileParseTime() {
  fetchGeoData();

  waitForGTMheapIdToBeSet();

  removeNoJsClass();

  const { userId } = window.analyticsGlobals;
  global.analytics.identify(
    userId,
    {},
    {
      integrations: {
        Heap: true
      }
    }
  );

  // send timing events on tick after the load event fires
  window.addEventListener('load', () => setTimeout(sendTimingEvents));

  if (isIE() || isOpera()) {
    (async () => {
      const { default: Stickyfill } = await import(/* webpackChunkName: "stickyfill" */ 'stickyfilljs');

      onContentLoaded(() => {
        const elements = document.querySelectorAll('.js-sticky');
        Stickyfill.add(elements);
      });
    })();
  }

  closestElementPolyfill();

  onPolyfillsLoaded(() => {
    instantiateWWWFormUtils();
  });

  await Promise.all([
    onContentLoaded(hookUpContactUs),
    onContentLoaded(initNavTrackingListeners),
    onContentLoaded(setupPhoneNumbersOnPage),
    onContentLoaded(setUpMobileMenuButtons),
    onContentLoaded(setUpGeoDataStuffAndListenForFooterInteractionsAndInitLocationSearch)
  ]);
}

doRandomStuffAtFileParseTime();
